import Vue from 'vue'
import contactLabelApi from '@/api/contactLabel.api'

const state = {
  labels: {}
}


const getters = {
  contactLabelById: (state) => (id) => {
    return state.labels[id]
  },

  contactLabels: (state) => {
    return Object.values(state.labels)
  }
}


const actions = {
  async loadContactLabels ({ commit, state, rootState }) {
    const response = await contactLabelApi.getLabels(rootState.tenant.current)
    commit('SET_LABELS', response.data)
  },

  async createContactLabel ({ commit, rootState }, label) {
    const response = await contactLabelApi.createLabel(rootState.tenant.current, label)
    commit('CREATE_LABEL', response.data)
  },

  async updateContactLabel ({ commit, dispatch, rootState }, label) {
    await contactLabelApi.updateLabel(rootState.tenant.current, label.id, label)
    commit('UPDATE_LABEL', label)
  },

  async deleteContactLabel ({ commit, dispatch, rootState }, id) {
    await contactLabelApi.deleteLabel(rootState.tenant.current, id)
    commit('DELETE_LABEL', id)
    dispatch('contact/removeLabelFromAllContacts', id, { root: true })
  }
}


const mutations = {
  SET_LABELS (state, labels) {
    state.labels = {}
    for (const label of labels) {
      Vue.set(state.labels, label.id, label)
    }
  },

  CREATE_LABEL (state, label) {
    Vue.set(state.labels, label.id, label)
  },

  UPDATE_LABEL (state, label) {
    Vue.set(state.labels, label.id, label)
  },

  DELETE_LABEL (state, id) {
    Vue.delete(state.labels, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
